import { type Middleware } from 'redux';

import { getExperimentValue } from '@canvas/client-feature-flags';

const CELL_SELECTION_ACTION_PREFIX = 'cellSelections/';

/**
 * For our experiment: ctd-5604-databases-selections-performance
 * this disables all cell selections middleware and cleanly turns them off. This will allow us
 * to properly swap the old selections engine with the new engine.
 *
 * @returns
 */
export const cellSelectionsNoOpMiddleware: Middleware = () => (next) => (action) => {
  if (
    typeof action.type === 'string' &&
    action.type.startsWith(CELL_SELECTION_ACTION_PREFIX) &&
    getExperimentValue('databasesSelectionsPerformance', 'isEnabled', {
      fireExperimentExposure: false,
    })
  ) {
    // Action was called, but we don't forward it to the reducer
    // You can add your own logic here, e.g., emit an event
    return action; // Return the action but don't call next()
  }

  return next(action);
};
